import React from 'react';
import { ESymbolKey } from "@smartsheet/forms-model";
import Full from "./Full";
import Half from "./Half";
import Quarter from "./Quarter";
import ThreeQuarters from "./ThreeQuarters";
import EmptyProgress from "./EmptyProgress";
import { WideIconOptionImg } from "../../iconUtil";
var ProgressIcon = function (_a) {
    var type = _a.type;
    var icon;
    switch (type) {
        case ESymbolKey.PROGRESS_5_100:
        case "Full":
            icon = React.createElement(Full, null);
            break;
        case ESymbolKey.PROGRESS_5_050:
        case "Half":
            icon = React.createElement(Half, null);
            break;
        case ESymbolKey.PROGRESS_5_025:
        case "Quarter":
            icon = React.createElement(Quarter, null);
            break;
        case ESymbolKey.PROGRESS_5_075:
        case "Three Quarter":
            icon = React.createElement(ThreeQuarters, null);
            break;
        case ESymbolKey.PROGRESS_5_000:
        case "Empty":
            icon = React.createElement(EmptyProgress, null);
            break;
        default:
            break;
    }
    return !!icon ? (React.createElement(WideIconOptionImg, null, icon)) : null;
};
export default ProgressIcon;
